export default __webpack_public_path__ + "static/media/mode-73.9e9a0c0a.svg";